import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, SxProps, Theme, Typography } from '@mui/material';
import { TypographyVariant } from '@mui/material';
import { Icons, StatusDot } from 'greener-ui-library';

type AccordionPanelProps = {
  children: React.ReactNode;
  contentStyles: React.CSSProperties;
  defaultExpanded?: boolean;
  divider?: boolean;
  title: string;
  titleVariant?: TypographyVariant;
  titleStyles?: React.CSSProperties;
  dotColor?: string;
  sx?: SxProps<Theme>;
};

export function AccordionPanel({
  children,
  contentStyles,
  defaultExpanded,
  divider = false,
  title,
  titleVariant = 'h5',
  titleStyles,
  dotColor,
  sx,
}: AccordionPanelProps) {
  return (
    <div>
      <Accordion defaultExpanded={defaultExpanded} sx={sx}>
        <AccordionSummary expandIcon={<Icons.ExpandMore />} sx={{ px: 3, height: '56px', ...titleStyles }}>
          <Box display="flex" alignItems="center" gap={1}>
            {dotColor && <StatusDot color={dotColor} />}
            <Typography variant={titleVariant}>{title}</Typography>
          </Box>
        </AccordionSummary>
        {divider && <Divider />}
        <AccordionDetails
          sx={{
            ...contentStyles,
          }}
        >
          {children}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
